import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { LoaderService } from '../service/loader.service';

@Injectable({
  providedIn: 'root',
})
export class ApiLoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let skip: boolean = request.headers.has('no-spinner');

    if (request.url?.includes('data-completion') || request.url?.includes('/purchasing/api/addToCart') || request.url?.includes('pricing')) {
      skip = true;
    }

    if (!skip) {
      this.loaderService.show();
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {}),
      finalize(() => {
        if (!skip) {
          this.loaderService.hide();
        }
      })
    );
  }
}
